module.exports = __webpack_public_path__ + "images/gems.png?b27c8b3f82ba326ade9807a85b166992";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grayIcons/gems.png
// module id = 315
// module chunks = 0